export const LOCATION_REQUEST = "LOCATION_REQUEST";
